<template>
  <v-layout column style="overflow-y: scroll; max-height: calc(100vh - 76px);">
    <v-toolbar dark class="toolbarcreatedadmin nonPrint" style="margin-top: 10px;">
      <v-btn icon @click="routeinfo()">
        <v-icon>fas fa-chevron-left</v-icon>
      </v-btn>
      <v-toolbar-title>รายละเอียดการขอความช่วยเหลือ</v-toolbar-title>
    </v-toolbar>
  <div style=" margin-top: 20px; margin-left: 20px;" v-if="data_helping">
    <table class="customers" style="width: 80vw;" >
      <tr>
        <th class="div_infor_header" style="width: 20vw;">ผู้ขอความช่วยเหลือ:</th>
        <td class="div_infor">{{data_helping.name_user_request}}</td>
        <th class="div_infor_header" style="width: 25vw;">ประเภทของการขอความช่วยเหลือ:</th>
        <td class="div_infor" v-if="data_helping.is_cpr && data_helping.is_runner">
          <v-chip small > cpr </v-chip> , <v-chip small style="background: #a80e00;color: white;"> AED </v-chip>
        </td>
        <td class="div_infor" v-else-if="data_helping.is_cpr">
          <v-chip small > cpr </v-chip>
        </td>
        <td class="div_infor" v-else-if="data_helping.is_runner">
          <v-chip small style="background: #a80e00;color: white;"> AED </v-chip>
        </td>
      </tr>

      <tr>
        <th class="div_infor_header">วัน เวลาขอความช่วยเหลือ:</th>
        <td class="div_infor">{{ dateMoment(data_helping.time_request)}} - {{ timeMoment(data_helping.time_request)}}น.</td>
        <th class="div_infor_header">วัน เวลายกเลิกขอความช่วยเหลือ:</th>
        <td class="div_infor">{{ dateMoment(data_helping.time_close_request)}} - {{ timeMoment(data_helping.time_close_request)}}น.</td>
        
      </tr>
      <tr>
        <th class="div_infor_header">ตำแหน่ง:</th>
        <td class="div_infor">lat: {{data_helping.location.latitude}} <br/>lon: {{data_helping.location.longitude}}</td>
        <th class="div_infor_header">สถานะ:</th>
        <td class="div_infor">{{(data_helping.status == 'open')? 'เปิด':'สำเร็จแล้ว' }} </td>
      </tr>
    </table>
  <br>
  <h3 style="text-align: left;" >อาสาสมัครที่ทำการตอบรับ</h3>
  <p v-if="data_helping.list_users_accept.length==0" style="text-align: left;"> &nbsp;&nbsp;&nbsp;&nbsp;ไม่มีอาสาสมัครกดตอบรับการช่วยเหลือ </p>
  <div v-else>
    <div v-if="count_vulunteer(data_helping.list_users_accept, 'cpr') != 0">
      <p style="text-align: left; margin-bottom: 0px !important;">ประเภท Hero CPR</p>
      <table class="customers" style="width: 80vw;">
        <tr>
          <th class="div_infor_header" style="text-align: center !important;">ชื่อ</th>
          <th class="div_infor_header" style="text-align: center !important;">เวลาในการตอบรับ</th>
        </tr>
        <tr v-for="item in vulunteer(data_helping.list_users_accept, 'cpr')">
          <td class="div_infor">{{ item.name_volunteer }}</td>
          <td class="div_infor">{{ dateMoment(item.accept_time)}} - {{ timeMoment(item.accept_time)}}น.</td>
        </tr>
      </table>
    </div>

    <div v-if="count_vulunteer(data_helping.list_users_accept, 'runner') != 0">
      <p style="text-align: left; margin-bottom: 0px !important;">ประเภท Run for AED</p>
      <table class="customers" style="width: 80vw;">
         <tr>
          <th class="div_infor_header" style="text-align: center !important;">ชื่อ</th>
          <th class="div_infor_header" style="text-align: center !important;">เวลาในการตอบรับ</th>
        </tr>
        <tr v-for="item in vulunteer(data_helping.list_users_accept, 'runner')">
          <td class="div_infor">{{ item.name_volunteer }}</td>
          <td class="div_infor">{{ dateMoment(item.accept_time)}} - {{ timeMoment(item.accept_time)}}น.</td>
        </tr>
      </table>
    </div>


    <div v-if="count_vulunteer(data_helping.list_users_accept, 'cancel') != 0">
      <p style="text-align: left; margin-bottom: 0px !important;">ปฏิเสธการให้การช่วยเหลือ</p>
      <table class="customers" style="width: 80vw;">
         <tr>
          <th class="div_infor_header" style="text-align: center !important;">ชื่อ</th>
          <th class="div_infor_header" style="text-align: center !important;">เวลาในการตอบรับ</th>
          <th class="div_infor_header" style="text-align: center !important;">เวลาในการยกเลิก</th>
        </tr>
        <tr v-for="item in vulunteer(data_helping.list_users_accept, 'cancel')">
          <td class="div_infor">{{ item.name_volunteer }}</td>
          <td class="div_infor">{{ dateMoment(item.accept_time)}} - {{ timeMoment(item.accept_time)}}น.</td>
          <td class="div_infor">{{ dateMoment(item.cancel_time)}} - {{ timeMoment(item.cancel_time)}}น.</td>
        </tr>
      </table>
    </div>
  </div>
</div>

  </v-layout>
</template>
<script>
import Vue from 'vue'
import ImageSlider from '@gaiaz/vue-image-slider'
import '@gaiaz/vue-image-slider/dist/image-slider.css'
import { Decode, Momenttime } from '@/services'
export default {
  data () {
    return {
      BASE_URL: process.env.BASE_URL,
      API_BACKEND: process.env.API_BACKEND,
      request_id: '',
      authen: {},
      headerAPI: '',
      typeCompany: 'partner',
      IdCompany: '',
      data_helping: {}
    }
  },
  created () {
    var decode = Decode.decode(localStorage.getItem('key'))
    this.authen = JSON.parse(decode)
    this.headerAPI = {Authorization: this.authen.Authorization}
    this.request_id = this.$route.query.id
    this.typeCompany = this.authen.typeCompany
    // console.log(this.authen)
    this.IdCompany = this.authen.idCompany
    this.getData()
  },
  mounted () {
  },
  computed: {
  },
  watch: {
  },
  methods: {
    vulunteer (list, type) {
      if (list.length == 0) {
        return []
      } else if (type == 'cancel') {
        return _.filter(list, { 'accept_status': type})
      } else {
        return _.filter(list, { 'type_accept': type, 'accept_status': 'accept'})
      }
    },
    count_vulunteer (list, type) {
      if (list.length == 0) {
        return 0
      } else if (type == 'cancel') {
        return _.filter(list, { 'accept_status': type}).length
      } else {
        return _.filter(list, { 'type_accept': type, 'accept_status': 'accept'}).length
      }
    },
    dateMoment(data) {
      return Momenttime.momentdatethai(data)
    },
    timeMoment(data) {
      return Momenttime.momenttimethai(data)
    },
    issueOpen () {
      this.$router.push('/information/issueAED?aed_id=' + this.aed_id)
    },
    GetListHistory () {
      this.$router.push('/information/historyAED?aed_id=' + this.aed_id)
    },
    print () {
      window.print()
    },
    routeinfo () {
      this.$router.back()
    },
    getData () {
      this.axios.get(process.env.API_BACKEND + '/v1/getAskForHelpDataByRequestID/' + this.request_id, {headers: this.headerAPI}).then((response) => {
        // console.log(response.data)
        this.data_helping = response.data
      })
    },
    checkOpentime (opening_time) {
      if (opening_time.open_type == 'someday'){
        var toggle = false;
        var listDay = []
        var item = 0
        for (item in opening_time.open_day) {
          listDay.push(this.dayOfWeekAsInteger(opening_time.open_day[item]))
        }
        listDay.sort()
        var display = ''

        for (var i=0; i <= listDay.length ; i++){
          if (i == 0) {
            display = '' + listDay[0]
          } else if (i == listDay.length-1) {
            if (listDay[i-1] == listDay[i]-1) {
              display = display + "-" + listDay[i]
            } else {
              display = display + "," + listDay[i]
            }
          } else if (i == listDay.length) {
            return this.thaiday(display)
          } else if (listDay[i-1] == listDay[i]-1){
          } else if (i == 1) {
            display = display + "," + listDay[i]

          } else {
            display = display + "-" + listDay[i-1] + "," + listDay[i]
          }
        }
      } else {
        return 'ทุกวัน'
      }
    },
    thaiday (day) {
      return day.replace('1', 'วันจันทร์').replace('2', 'วันอังคาร').replace('3', 'วันพุธ').replace('4', 'วันพฤหัสบดี').replace('5', 'วันศุกร์').replace('6', 'วันเสาร์').replace('7', 'วันอาทิตย์')
    },
    dayOfWeekAsInteger(day) {
      return ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'].indexOf(day) + 1
    }
  }
}
</script>
<style media="screen" scoped>
  .fonts {
    font-family: 'Sarabun', sans-serif !important;
  }
  .positionPrint {
    width: 70vw;
    margin-left: 30vw;
    text-align: right;
    padding-right: 16vw;
  }

   .customers {
  font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
  border-collapse: collapse;
}

.customers td, .customers th {
  border: 1px solid #ddd;
  padding: 8px;
}


.customers th {
  background-color: #a80d00;
  color: white;
  padding-top: 5px;
  padding-bottom: 5px;
  padding-right: 10px;
  /*text-align: right !important;*/
}
.customers td {
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 10px;
  text-align: left !important;
  width: 400px;
}

  @media screen {
    #PDF {
      height: 60vh !important;
      overflow: scroll;
    }
    .pdfSection {
      display: none;
    }
  }
  @media print {
    .pdfSection {
      display: show;
      -webkit-print-color-adjust: exact; 
    }
    .nonPrint {
      display: none;
    }
    #PDF {
      height: auto;
      overflow: hidden;
    }
    .pageBreak { page-break-inside:always; }
    .pageBreak * {
      page-break-after:avoid;
      page-break-before:avoid;
    }
  }
  >>>.material-icons {
    font-family: 'Material Icons';
    font-weight: normal;
    font-style: normal;
    font-size: 33px;
    line-height: 1;
    letter-spacing: normal;
    text-transform: none;
    display: inline-block;
    white-space: nowrap;
    word-wrap: normal;
    direction: ltr;
    -webkit-font-feature-settings: 'liga';
    -webkit-font-smoothing: antialiased;
  }
  .fonts-icons {
    font-size: 55px !important;
  }
  .border-images {
    border-color: #a80e00 !important;
    border-style: solid !important;
    width: 450px !important;
    border-radius: 20px !important;
    margin-bottom: 20px !important;
  }
  >>>.accent {
    background-color: #8c0c00 !important;
  }

  .div_infor_button {
    height: 40px !important;
    width: 400px !important;
    margin-top: 30px !important;
    justify-content: center !important;
    display: flex !important;
    align-items: center !important;
    font-size: 18px !important;
  }
  .div_infor_button_help {
    background-color: white !important;
    height: 40px !important;
    width: 100% !important;
    margin-top: 30px !important;
    justify-content: center !important;
    display: flex !important;
    align-items: center !important;
    font-size: 18px !important;
  }
  >>>.white {
    width: 100% !important;
    background-color: #fff!important;
    border-color: #fff!important;
  }
  >>>.theme--dark.v-text-field--solo>.v-input__control>.v-input__slot {
    border-radius: 30px;
    background: #ffffff;
    color: #a80e00;
    border-color: #a80e00;
    border-style: solid;
    border-width: thin;
  }
  .inputinfor_address {
    height: 110px !important;
    border-width: thin !important;
    border-style: solid !important;
    border-color: #a80e00 !important;
    border-radius: 7px !important;
    background-color: white !important;
  }
  .inputinfor {
    height: 50px !important;
    border-width: thin !important;
    border-style: solid !important;
    border-color: #a80e00 !important;
    border-radius: 7px !important;
    background-color: white !important;
  }
  .inputinfor_dis {
    height: 50px !important;
    border-width: thin !important;
    border-style: solid !important;
    border-color: #a80e00 !important;
    border-radius: 7px !important;
    background-color: #FAF0F0 !important;
  }
  >>>.theme--dark.v-select .v-select__selections {
      color: #a80e00 !important;
  }
  >>>.theme--dark.v-label {
      color: hsl(5, 100%, 33%) !important;
  }
  >>>.theme--dark.v-icon {
      color: #a80e00 !important;
  }
  >>>.theme--dark.v-input:not(.v-input--is-disabled) input {
    color: #a80e00 !important;
  }
  .toolbarcreatedadmin {
    border-top-color: transparent !important;
    border-left-color: transparent !important;
    border-width: thin !important;
    border-right-color: transparent !important;
    border-style: solid !important;
    height: 64px !important;
    border-left-style: initial !important;
    border-right-style: initial !important;
    border-radius: 0px !important;
    border-bottom-color: #a80e00 !important;
    background-color: white !important;
    color: #a80e00 !important;
    border-width: thin !important;
    box-shadow: none !important;
  }
  .btngen {
    background-color: white !important;
    color: #a80f00 !important;
    border-color: #a80f00 !important;
    border-style: solid !important;
    border-width: thin !important;
    text-transform: none !important;
    width: 120px !important;
  }
  .btncreateuser {
    background-color: #a80f00 !important;
    color: #fafafa !important;
    border-color: #a80f00 !important;
    border-style: solid !important;
    border-width: thin !important;
    text-transform: none !important;
  }
  .btncreateuser:disabled {
    background-color: #a80f0099 !important;
    color: #fafafa9c !important;
    border-color: #a80f0091 !important;
    border-style: solid !important;
    border-width: thin !important;
  }

  .btncancle {
    background-color: #fafafa !important;
    color: #a80f00 !important;
    border-color: #a80f00 !important;
    border-style: solid !important;
    border-width: thin !important;
    width: 160px !important;
  }

  .div_infor_header {
    background: rgb(168, 14, 0) !important;
    color: white;
    text-align: right;
    padding-right: 10px;
    font-size: 15px;
    padding-right: 10px;
    border: 1px solid #a80d00 !important;
  }
  .div_infor {
    width: 20vw;
    /*border: solid 1px #a80d00;*/
    text-align: left;
    padding-left: 10px;
    font-size: 15px;
    padding-left: 10px;
    border: 1px solid #a80d00 !important;
  }

  .tableInfor {
    justify-content: center;
    display: inline-table;
    width: 40vw;
  }
</style>



// WEBPACK FOOTER //
// src/components/information_print/infor_help.vue